import { z } from 'zod';
export const BILLING_PLAN_SLUGS = {
    PRO: 'pro',
};
export const billingCheckoutRequestSchema = z.object({
    slug: z.literal(BILLING_PLAN_SLUGS.PRO),
}).strict();
export const billingCheckoutResponseSchema = z.object({
    success: z.literal(true),
    data: z.object({
        url: z.url(),
    }),
});
